/* Makhokhar theme interactions */
(function () {
  'use strict';

  /* ---- scroll reveal ---- */
  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.mk-rv:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- tabs ---- */
  function tabs(scope) {
    (scope || document).querySelectorAll('[data-mk-tabs]').forEach(function (root) {
      if (root.dataset.mkReady) return;
      root.dataset.mkReady = '1';
      root.querySelectorAll('.mk-tab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-target');
          root.querySelectorAll('.mk-tab').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
          root.querySelectorAll('.mk-panel').forEach(function (p) {
            var on = p.getAttribute('data-panel') === id;
            p.classList.toggle('is-on', on);
            if (on) { var c = p.querySelector('[data-mk-carousel]'); if (c && c.mkSync) c.mkSync(); }
          });
        });
      });
    });
  }

  /* ---- carousel ---- */
  function carousels(scope) {
    (scope || document).querySelectorAll('[data-mk-carousel]').forEach(function (root) {
      if (root.dataset.mkReady) return;
      root.dataset.mkReady = '1';
      var track = root.querySelector('.mk-carousel__track');
      var cells = root.querySelectorAll('.mk-carousel__cell');
      var prev = root.querySelector('.mk-arrow--prev');
      var next = root.querySelector('.mk-arrow--next');
      if (!track || !cells.length) return;
      var i = 0;
      function per() {
        var w = root.querySelector('.mk-carousel__view').offsetWidth;
        var cw = cells[0].offsetWidth || 1;
        return Math.max(1, Math.round(w / cw));
      }
      function max() { return Math.max(0, cells.length - per()); }
      function go() {
        if (i > max()) i = max();
        if (i < 0) i = 0;
        track.style.transform = 'translateX(' + (-i * (100 / cells.length) * cells.length / per() * per() / cells.length * cells.length / cells.length) + '%)';
        track.style.transform = 'translateX(' + (-(i * cells[0].offsetWidth)) + 'px)';
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i >= max();
      }
      root.mkSync = go;
      if (prev) prev.addEventListener('click', function () { i -= per(); go(); });
      if (next) next.addEventListener('click', function () { i += per(); go(); });
      var sx = null;
      root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 45) { i += dx < 0 ? per() : -per(); go(); }
        sx = null;
      });
      window.addEventListener('resize', function () { clearTimeout(root._t); root._t = setTimeout(go, 160); });
      go();
    });
  }

  /* ---- slideshow (hero / promo) ---- */
  function slideshows(scope) {
    (scope || document).querySelectorAll('[data-mk-slider]').forEach(function (root) {
      if (root.dataset.mkReady) return;
      root.dataset.mkReady = '1';
      var slides = root.querySelectorAll('[data-slide]');
      var dots = root.querySelectorAll('.mk-dot');
      if (slides.length < 1) return;
      var i = 0, timer = null;
      var delay = (parseInt(root.getAttribute('data-autoplay'), 10) || 0) * 1000;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, x) { s.classList.toggle('is-on', x === i); });
        dots.forEach(function (d, x) { d.classList.toggle('is-on', x === i); });
      }
      function play() { if (delay > 0 && slides.length > 1) { stop(); timer = setInterval(function () { show(i + 1); }, delay); } }
      function stop() { if (timer) clearInterval(timer); }
      var p = root.querySelector('.mk-nav-btn--prev');
      var n = root.querySelector('.mk-nav-btn--next');
      if (p) p.addEventListener('click', function () { show(i - 1); play(); });
      if (n) n.addEventListener('click', function () { show(i + 1); play(); });
      dots.forEach(function (d, x) { d.addEventListener('click', function () { show(x); play(); }); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
      show(0); play();
    });
  }

  /* ---- add to cart ---- */
  function cart(scope) {
    (scope || document).querySelectorAll('[data-mk-add]').forEach(function (btn) {
      if (btn.dataset.mkReady) return;
      btn.dataset.mkReady = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-mk-add');
        if (!id) return;
        var label = btn.textContent;
        btn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) { return r.json(); }).then(function () {
          btn.textContent = 'Added ✓';
          return fetch('/cart.js').then(function (r) { return r.json(); });
        }).then(function (c) {
          document.querySelectorAll('[data-mk-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
          setTimeout(function () { btn.textContent = label; }, 1600);
        }).catch(function () { btn.textContent = label; });
      });
    });
  }

  /* ---- mobile nav ---- */
  function burger() {
    var b = document.querySelector('[data-mk-burger]');
    var n = document.querySelector('.mk-nav');
    if (b && n && !b.dataset.mkReady) {
      b.dataset.mkReady = '1';
      b.addEventListener('click', function () { n.classList.toggle('is-open'); });
    }
  }

  function init(scope) { reveal(scope); tabs(scope); carousels(scope); slideshows(scope); cart(scope); burger(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
